import React from "react";
import classnames from "classnames";

import BannerAdContainer from "@/app/pages/companyProfile/bannerAdContainer/BannerAdContainer";
import { useTranslation } from "react-i18next";
import { usePageURL } from "@/shared/customHooks";
import "@/app/pages/companyProfile/scoreRatingsAdPurple/ScoreRatingsAdPurple.scss"
import { track_event } from "@/shared/FunctionCore";

const ScoreRatingsAdPurple = ({ forPage }): JSX.Element => {
  const { t } = useTranslation();
  const { countryCode, dunsNumber } = usePageURL();
  const pageName = forPage === "contactProfilePurpleAd" ? "contactProfile" : "companyProfile";

  const freeLink = () => {
    if (forPage === "contactProfilePurpleAd") {
      return t("contactProfile.scoreRatingPurpleAdBanner.link")
    }
    // business directory
    if (countryCode == 'de' || countryCode == 'at') {
      return `${t("companyProfile.scoreRatingPurpleAdBanner.buttonLink")}${dunsNumber}`
    }
    return t("companyProfile.scoreRatingPurpleAdBanner.buttonLink")
  }

  return (
    <BannerAdContainer bodyClass="scores-ratings-ad" forPage={forPage}>
      <div className={classnames({
        "scores-ratings": true,
        "contact-purple-banner gap-5": forPage === "contactProfilePurpleAd"
      })}>
        <div className={classnames({
          "details": true,
          "w-75": forPage === "contactProfilePurpleAd"
        })}>
          {forPage === "contactProfilePurpleAd" &&
            <div className="detail">
              {t("contactProfile.scoreRatingPurpleAdBanner.line1")}
            </div>
          }
          <div className="score-rating-detail">
            {/* <font style={{ verticalAlign: "inherit" }}> */}
            {t(`${pageName}.scoreRatingPurpleAdBanner.description`)}
            {/* </font> */}
          </div>
        </div>
        <a
          className="scores-ratings-button ext-icon"
          id="link"
          href={freeLink()}
          onClick={() => track_event('scores-and-ratings-ad-link-clicked')}
          target="_blank"
          rel="noreferrer"
        >
          {/* <font style="vertical-align: inherit;"> */}
          {/* <script>
        var url = window.location.href;
        var splittedArray = url.split('.');
        var dunsNumber = splittedArray[splittedArray.length-2];
        document.getElementById('link').href = ' https://www.dnb.com/de-de/firmensuche/das-datenuniversum?DUNS='+dunsNumber;
        </script> */}
          {t(`${pageName}.scoreRatingPurpleAdBanner.buttonLabel`)}
          {/* </font>  */}
        </a>
      </div>
    </BannerAdContainer>
  );
}

export default ScoreRatingsAdPurple;
